module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"error":{"404":{"link":"Ir para home","title":"Essa página não existe."}}},"en-US":{"error":{"404":{"link":"Go to home","title":"This page does not exist."}}}}')
  delete Component.options._Ctor
}
